import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { TreatmentComponent } from "@/services/backend/rlt/treatments/components/treatment-component";
import { useRltConfirmationShowQuery } from "@/services/backend/rlt/confirmations/api/confirmation-api";
import { Column } from "@/services/backend/rlt/treatments/lib/treatment-component-state";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import t from "@/lang/lang";
import { TreatmentRemark } from "@/services/backend/rlt/treatments/components/treatment-remark";

export function ConfirmationTreatmentRoute() {
  const { confirmationId } = useParams();
  const {
    data: confirmation,
    isLoading,
    error,
  } = useRltConfirmationShowQuery({ id: confirmationId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <TreatmentComponent
        treatmentId={confirmation!.treatmentId}
        disabled={confirmation!.immutable}
        availableColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.ComponentData,
          Column.Cycle,
          Column.Formula,
          Column.CleanTime,
          Column.BasePrice,
          Column.CycleDiscount,
          Column.SpecialDiscount,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
        defaultColumns={[
          Column.Position,
          Column.ComponentKind,
          Column.BasePrice,
          Column.CycleDiscount,
          Column.FinalPrice,
          Column.Comment,
          Column.Actions,
        ]}
      />
      <TreatmentRemark
        treatmentId={confirmation!.treatmentId}
        disabled={confirmation!.immutable}
      />
      <Textblocks
        subdomain={GSMSubdomain.RLT}
        documentKind={GSMDocumentKind.Treatment}
        documentId={confirmation!.treatmentId}
        title={t("Allgemeine Bemerkungen in Leistungsverzeichnis")}
        defaultOpen={false}
      />
    </div>
  );
}
